import type { ComponentProps, ReactNode } from "react";

import type * as Renderers from "./renderers";

export { ReadableCopy, readableFallback } from "./ReadableFallback";

type RendererName = keyof typeof Renderers;
type Renderer<Name extends RendererName> = (
  props: ComponentProps<(typeof Renderers)[Name]>,
) => ReactNode;

// Copies only ever render on the server. Next.js compiles `typeof window` to a
// constant, so the browser bundle drops this require and never ships the
// renderers; the browser only needs component references to create elements.
const renderers: typeof Renderers | undefined =
  typeof window === "undefined" ? require("./renderers") : undefined;

const serverOnly = <Name extends RendererName>(name: Name): Renderer<Name> =>
  (renderers?.[name] as Renderer<Name> | undefined) ?? (() => null);

export const ReadableValue = serverOnly("ReadableValue");
export const ReadableArticle = serverOnly("ReadableArticle");
export const ReadableIndex = serverOnly("ReadableIndex");
export const ReadableResourceAsset = serverOnly("ReadableResourceAsset");
export const ReadableVideoAsset = serverOnly("ReadableVideoAsset");
